export function getCookie(name: string) {
    if (!document.cookie) {
        return null;
    }

    const ca: Array<string> = document.cookie.split(';');
    const cookieName = `${name}=`;

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();

        if (c.indexOf(cookieName) === 0) {
            return c.substring(cookieName.length);
        }
    }

    return null;
}

export function clearCookie(name: string): void {
    const expiry = "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    // Clear the host-only cookie (e.g. on localhost) and the
    // .teuteuf.fr-domain cookie — only the matching one takes effect.
    document.cookie = name + expiry;
    document.cookie = name + expiry + " domain=.teuteuf.fr;";
}